"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToGA4Attribute = exports.GA4EventEnum = void 0;
require("core-js/modules/es6.function.name.js");
function cov_1vvltdihpr() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/GA4ConvertUtils.js";
  var hash = "1c5be8b17bbddf32053f483bc58e416f81b7de7b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/GA4ConvertUtils.js",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 28
        },
        end: {
          line: 6,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 37
        },
        end: {
          line: 54,
          column: 1
        }
      },
      "2": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 52,
          column: 3
        }
      },
      "3": {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 19,
          column: 8
        }
      },
      "4": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 12
        }
      },
      "5": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 27,
          column: 8
        }
      },
      "6": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 12
        }
      },
      "7": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 38,
          column: 8
        }
      },
      "8": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 39,
          column: 12
        }
      },
      "9": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 47,
          column: 8
        }
      },
      "10": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 12
        }
      },
      "11": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 20
        }
      },
      "12": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 12
        }
      },
      "13": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 53,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 37
          },
          end: {
            line: 8,
            column: 38
          }
        },
        loc: {
          start: {
            line: 8,
            column: 65
          },
          end: {
            line: 54,
            column: 1
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 20,
            column: 12
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 28,
            column: 12
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 39,
            column: 12
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 48,
            column: 12
          }
        }, {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 51,
            column: 12
          }
        }],
        line: 10
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1c5be8b17bbddf32053f483bc58e416f81b7de7b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1vvltdihpr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1vvltdihpr();
var GA4EventEnum = exports.GA4EventEnum = (cov_1vvltdihpr().s[0]++, {
  productImpression: 'productImpression',
  promoImpression: 'promoImpression',
  productClick: 'productClick',
  promoClick: 'promoClick'
});
cov_1vvltdihpr().s[1]++;
var convertToGA4Attribute = exports.convertToGA4Attribute = function convertToGA4Attribute(event, data, orderType) {
  cov_1vvltdihpr().f[0]++;
  var result;
  cov_1vvltdihpr().s[2]++;
  switch (event) {
    case GA4EventEnum.productImpression:
      cov_1vvltdihpr().b[0][0]++;
      cov_1vvltdihpr().s[3]++;
      result = {
        item_id: data.id,
        item_name: data.name,
        item_brand: data.brand,
        item_list_name: data.list,
        index: data.position,
        type: data.type
      };
      cov_1vvltdihpr().s[4]++;
      break;
    case GA4EventEnum.promoImpression:
      cov_1vvltdihpr().b[0][1]++;
      cov_1vvltdihpr().s[5]++;
      result = {
        item_id: data.id,
        item_name: data.name,
        index: data.position,
        creative: data.creative
      };
      cov_1vvltdihpr().s[6]++;
      break;
    case GA4EventEnum.productClick:
      cov_1vvltdihpr().b[0][2]++;
      cov_1vvltdihpr().s[7]++;
      result = {
        item_id: data.id,
        item_name: data.name,
        item_brand: data.brand,
        item_list_name: data.list,
        index: data.position,
        type: data.type,
        item_variant: orderType
      };
      cov_1vvltdihpr().s[8]++;
      break;
    case GA4EventEnum.promoClick:
      cov_1vvltdihpr().b[0][3]++;
      cov_1vvltdihpr().s[9]++;
      result = {
        item_id: data.id,
        item_name: data.name,
        index: data.position,
        creative: data.creative,
        item_variant: orderType
      };
      cov_1vvltdihpr().s[10]++;
      break;
    default:
      cov_1vvltdihpr().b[0][4]++;
      cov_1vvltdihpr().s[11]++;
      result = data;
      cov_1vvltdihpr().s[12]++;
      break;
  }
  cov_1vvltdihpr().s[13]++;
  return result;
};